import React from "react";
import { Container, Row } from "reactstrap";
import AuditSummary from "./Summary/AuditSummary";
import BreadCrumb from "Components/Common/BreadCrumb";
import { withTranslation } from "react-i18next";

const Audit = ({t}: any) => {
	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<BreadCrumb title={t("footprints.footprints")} pageTitle={t("footprints.summary")} icon="ri-list-check" />
					<Row>
						<AuditSummary />
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Audit);
